import { $authHost } from './index';
import { fetchCsrfToken } from './userAPI';

export const fetchUserNotifications = async () => {
    const { data } = await $authHost.get('api/notification/user');
    return data;
};

export const fetchNotifications = async () => {
    const { data } = await $authHost.get('api/notification');
    return data;
};

export const removeUserNotification = async (id) => {
    const csrfToken = await fetchCsrfToken();
    const { data } = await $authHost.delete(`api/notification/${id}`, { data: { _csrf: csrfToken } });
    return data;
};

export const markNotificationRead = async (id) => {
    const csrfToken = await fetchCsrfToken();
    const { data } = await $authHost.patch(`api/notification/${id}/read`, { _csrf: csrfToken });
    return data;
}; 